import router from '@/router'
import * as types from '@/store/types.js'
import Category from '@/model/Category'
import {activeResource} from '@/store/helpers'
import app from '../../main'

const state = {
  categories: [],
  activeCategory: {
    additionals: {},
    languages: {
      hr: {
        additionals: {}
      },
      en: {
        additionals: {}
      }
    }
  },
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_CATEGORIES]: state => state.categories,
  [types.ACTIVE_CATEGORY]: state => state.activeCategory,
  [types.IS_LOADING_CATEGORIES]: state => state.isLoading,
  [types.ALL_CATEGORIES_TREE]: (state) => {
    let list = JSON.parse(JSON.stringify(state.categories)) // Clone categories
    let map = {}
    let node
    let roots = []
    let i

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i
      list[i].subCategories = []
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i]
      if (!node.parent_id) {
        roots.push(node)
      } else {
        list[map[node.parent_id]].subCategories.push(node)
      }
    }
    return roots
  }
}

// ACTIONS
const actions = {
  [types.GET_ALL_CATEGORIES]: ({ commit }, value) => {
    commit(types.GET_ALL_CATEGORIES, value)
  },
  [types.ADD_CATEGORY]: ({ commit }, value) => {
    commit(types.ADD_CATEGORY, value)
  },
  [types.UPDATE_CATEGORY]: ({ commit }, value) => {
    commit(types.UPDATE_CATEGORY, value)
  },
  [types.REMOVE_CATEGORY]: ({ commit }, value) => {
    commit(types.REMOVE_CATEGORY, value)
  },
  [types.ACTIVE_CATEGORY]: ({ commit }) => {
    commit(types.ACTIVE_CATEGORY)
  },
  [types.UPDATE_CATEGORY_URL]: ({ commit }, value) => {
    commit(types.UPDATE_CATEGORY_URL, value)
  },
  [types.IS_LOADING_CATEGORIES]: ({ commit }, value) => {
    commit(types.IS_LOADING_CATEGORIES, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_CATEGORIES] (state, value) {
    state.categories = value.data
  },
  [types.ADD_CATEGORY]: (state, value) => {
    state.categories.unshift(value)
  },
  [types.UPDATE_CATEGORY]: (state, value) => {
    state.activeCategory = value
  },
  [types.REMOVE_CATEGORY]: (state, value) => {
    Category.delete(value).then((response) => {
      state.categories.forEach(category => {
        if (category.parent_id === value.id) {
          category.parent_id = null
        }
      })

      state.categories = state.categories.filter(obj => value.id !== obj.id)
      app.$snotify.success('Successfully deleted.')

      // If route is the same as deleted resource we need to redirect to /categories
      if (router.currentRoute.params.id === value.id) {
        router.push({ name: 'categories.index' })
      }
    })
  },
  [types.ACTIVE_CATEGORY]: (state, value) => {
    state.activeCategory = activeResource(state.categories)
    console.log(state.activeCategory)
  },
  [types.UPDATE_CATEGORY_URL]: (state, value) => {
    state.activeCategory.languages[value.language].url = value.url
  },
  [types.IS_LOADING_CATEGORIES]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Category.js